import React from 'react';

import * as Page from 'components/page';
import * as List from 'components/list';

import logoRanking from 'assets/images/logo-ranking.svg';

import { iframeLink } from 'core/iframe/IframeLink';

import { RankingCard } from './RankingCard';

import * as Styled from './StyledRankingSelect';

export const RankingSelect = props => {
    // Create the secondary actions options
    const actions = [
        {
            id: 1,
            href: iframeLink('https://100os.net/ranking-acerca'),
            text: props.t('StartupIndex.RankingAbout'),
        },
        {
            id: 2,
            href: '/support',
            text: props.t('StartupIndex.HelpAndSupport'),
        },
    ];

    return (
        <Styled.RankingSelect as={Page.Page} name="RankingSelect" back="/ranking">
            <Page.Image>
                <img src={logoRanking} alt="Logo Ranking 100 Open Startups" />
            </Page.Image>

            <Page.Title>{props.t('RankingSelect.title')}</Page.Title>
            <Page.Descr>{props.t('RankingSelect.descr')}</Page.Descr>

            <Styled.RankingContainer>
                <RankingCard countryId="BR" />
                <RankingCard countryId="CO" />
            </Styled.RankingContainer>

            <List.List name="RankingSelectActions">
                <List.Vertical items={actions} itemKey="id" />
            </List.List>
        </Styled.RankingSelect>
    );
};
export default RankingSelect;
